/* =========================================================================
   Upgreens: Konfigurator (sections/ug-konfigurator.liquid)

   AUFBAU
   Der Ablauf ist immer derselbe und steht in `aktualisieren()`:

       Zustand  ->  auswahl()  ->  ANZEIGEN[]

   `auswahl()` rechnet ALLES aus, was sich aus der Auswahl ergibt — Preis,
   Variante, Katalogtreffer, Sonderweg — und fasst es zu einem Ergebnis
   zusammen. Erst danach fasst irgendetwas das Dokument an.

   Diese Trennung ist der Grund, warum die Funktionen hier klein bleiben: die
   rechnenden kennen kein DOM, die anzeigenden rechnen nichts. Jede
   Anzeigefunktion bekommt denselben fertigen Befund und schreibt ihn an eine
   Stelle. Neue Anzeige heisst: Funktion schreiben, in ANZEIGEN eintragen.

   PREISREGEL (die Werte kommen aus dem Theme-Editor, nicht von hier):
     Grundpreis
       + Aufpreis je Ebene, deren gewaehlte Option "holz" traegt
     Bei "ral" oder "material" gilt stattdessen der jeweilige Grundpreis.
     Ebenen mit "folgt Furnier" sind dann gesperrt und kosten nichts extra —
     sie tragen dasselbe Material. Andere Aufpreise (Echtholz-Staebe) kommen
     weiterhin dazu.

   DIE VARIANTE WIRD UEBER DEN PREIS GEFUNDEN, nicht ueber ID oder Name.
   Siehe Kopf der Sektion.

   Das Hinzufuegen in den Warenkorb macht Mottos `<product-form>`. Hier wird
   nur vorbereitet, was dieses Formular abschickt.
   ========================================================================= */
(function () {
  'use strict';

  function ugEvent(name, data) {
  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish(name, data);
  }
}

  /* Woher kommt der Besucher in den Konfigurator?
     produktseite = von der Kitchenforest-Produktseite gewechselt
     shop         = von einer anderen Seite im Shop
     anzeige      = direkt aus einer Meta-Anzeige (fbclid oder utm_source=meta)
     extern       = von einer anderen Website
     direkt       = ohne Herkunft (getippt, Lesezeichen, App) */
  function herkunft() {
    let ref = null;
    try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) { ref = null; }
    const suche = new URLSearchParams(window.location.search);
    if (ref && ref.hostname === window.location.hostname) {
      return /\/products\/kitchenforest\/?$/.test(ref.pathname) ? 'produktseite' : 'shop';
    }
    if (suche.has('fbclid') || suche.get('utm_source') === 'meta') return 'anzeige';
    return ref ? 'extern' : 'direkt';
  }

  const EDITOR = !!(window.Shopify && window.Shopify.designMode);

  /* Texte, die dieses Skript selbst in die Seite schreibt, kommen aus
     snippets/ug-texte.liquid (window.ugText) und damit aus locales/. Fest
     im Skript erreichte sie Translate & Adapt nie; auf der englischen
     Live-Seite stand „RAL-Nummer deiner Kueche". Fehlt das Snippet, gilt
     der deutsche Notnagel. Platzhalter: {name}. */
  const ugT = (schluessel, notnagel, werte) => {
    if (window.ugText) return window.ugText(schluessel, notnagel, werte);
    return Object.keys(werte || {}).reduce((t, k) => t.split('{' + k + '}').join(String(werte[k])), notnagel);
  };

  /* In HTML-Vorlagen: eine Uebersetzung mit Anfuehrungszeichen wuerde sonst
     das Attribut beenden. */
  const ugHtml = (s) => String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

  /* ======================================================================
     1 · Farben
     ---------------------------------------------------------------------
     Der Abstand zweier Farben wird in Lab gemessen, nicht in RGB. In RGB
     liegen Dunkelgruen und Dunkelbraun rechnerisch naeher beieinander als
     Hellgrau und Weiss — das Auge sieht es umgekehrt. Lab ist so gebaut,
     dass gleiche Abstaende ungefaehr gleich grossen wahrgenommenen
     Unterschieden entsprechen.
     ====================================================================== */

  function hexZuRgb(hex) {
    let h = String(hex || '').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (!/^[0-9a-f]{6}$/i.test(h)) return null;
    return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  }

  function rgbZuLab(rgb) {
    const v = rgb.map((k) => {
      const x = k / 255;
      return x > 0.04045 ? Math.pow((x + 0.055) / 1.055, 2.4) : x / 12.92;
    });
    // sRGB -> XYZ (D65), bezogen auf das Normlicht
    const x = (v[0] * 0.4124 + v[1] * 0.3576 + v[2] * 0.1805) / 0.95047;
    const y = v[0] * 0.2126 + v[1] * 0.7152 + v[2] * 0.0722;
    const z = (v[0] * 0.0193 + v[1] * 0.1192 + v[2] * 0.9505) / 1.08883;
    const f = (t) => (t > 0.008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116);
    return [116 * f(y) - 16, 500 * (f(x) - f(y)), 200 * (f(y) - f(z))];
  }

  function abstand(a, b) {
    return Math.sqrt(a.reduce((s, k, i) => s + (k - b[i]) * (k - b[i]), 0));
  }

  function labVon(hex) {
    const rgb = hexZuRgb(hex);
    return rgb ? rgbZuLab(rgb) : null;
  }

  /* Naechstliegende Option einer Ebene zu einem Farbwert. Sonderwege haben
     keine eigene Farbe und kommen darum nicht in Frage. */
  function naechsteOption(ebene, hex) {
    const ziel = labVon(hex);
    if (!ziel) return null;
    const mitFarbe = ebene.optionen
      .filter((o) => !istSonder(o) && labVon(o.farbe))
      .map((o) => ({ o, d: abstand(ziel, labVon(o.farbe)) }))
      .sort((a, b) => a.d - b.d);
    return mitFarbe.length ? mitFarbe[0].o : null;
  }

  /* ======================================================================
     2 · Optionen und Kennungen
     ====================================================================== */

  function kennungen(option) {
    return String((option && option.kennungen) || '')
      .split(',')
      .map((k) => k.trim())
      .filter(Boolean);
  }

  const hat = (option, name) => kennungen(option).indexOf(name) !== -1;
  const istSonder = (option) => hat(option, 'ral') || hat(option, 'material');
  const sonderArt = (option) => (hat(option, 'ral') ? 'ral' : hat(option, 'material') ? 'material' : null);

  function gewaehlt(z, i) {
    const ebene = z.daten.ebenen[i];
    if (!ebene || !ebene.optionen.length) return null;
    return ebene.optionen[Math.min(z.wahl[i], ebene.optionen.length - 1)] || null;
  }

  /* ======================================================================
     2b · Platzhalter in Dateinamen
     ---------------------------------------------------------------------
     Der neue Bildersatz kennt Ebenen, die von MEHR ALS EINER Wahl abhaengen.
     Acrylglas-Stangen spiegeln die Kueche und den Koerper, es gibt sie also
     zwoelfmal:

         kf-stangen-acryl-{kueche}-{gehaeuse}.webp

     `{kueche}` steht fuer das Kuerzel einer anderen Ebene und wird durch den
     Kurznamen ihrer gewaehlten Option ersetzt. Damit bleibt die Zuordnung
     dort, wo sie hingehoert: im Theme-Editor, als Dateiname.

     Ohne Platzhalter aendert sich nichts — eine schlichte Datei bleibt eine
     schlichte Datei.
     ====================================================================== */

  /* „Weiß" -> „weiss". Muss dieselbe Regel sein wie in
     00_tools/konfigurator-bilder.js, sonst zeigen die Namen ins Leere. */
  function kurzname(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /* „beige=schwarz, orange=schwarz" -> { beige: 'schwarz', orange: 'schwarz' }

     Wofuer: nicht jede Wahl hat ein eigenes Rendering. Das Kabel etwa gibt
     es nur in Schwarz und Weiss — und das ist richtig so, denn im Geraet
     steckt bei einem beigen oder orangen Koerper ein schwarzes Kabel. Ohne
     diese Zuordnung fiele die Ebene dort einfach aus, und das Kabel waere
     unsichtbar statt schwarz.

     Bewusst hier und nicht als Kopie der Bilddatei unter falschem Namen:
     zwei Dateien mit gleichem Inhalt sehen im Dateienordner aus wie ein
     Versehen, und niemand weiss spaeter, welche die echte ist. */
  function ersatzwerte(text) {
    const karte = {};
    String(text || '').split(',').forEach((teil) => {
      const [von, nach] = teil.split('=').map((x) => (x || '').trim().toLowerCase());
      if (von && nach) karte[von] = nach;
    });
    return karte;
  }

  function einsetzen(muster, z, a, ebene) {
    if (!muster || muster.indexOf('{') === -1) return muster;
    const karte = ersatzwerte(ebene && ebene.zuordnung);
    return muster.replace(/\{([a-z0-9_]+)\}/gi, (ganz, schluessel) => {
      const i = z.daten.ebenen.findIndex((e) => e.schluessel === String(schluessel).toLowerCase());
      if (i === -1) return ganz;
      const opt = a.sonder && a.sonder.ebene === i ? ersatzOption(z, z.daten.ebenen[i]) : gewaehlt(z, i);
      if (!opt) return ganz;
      // Der eigene Kurzname hat Vorrang: „Salz" heisst als Datei
      // `platinweiss`, und aus dem Anzeigenamen liesse sich das nicht
      // ableiten.
      const wert = opt.kurz || kurzname(opt.wert);
      return karte[wert] || wert;
    });
  }

  function gleichnamig(ebene, vorbild) {
    if (!vorbild) return ebene.optionen[0] || null;
    const treffer = ebene.optionen.filter((o) => o.wert === vorbild.wert);
    return treffer.length ? treffer[0] : ebene.optionen[0] || null;
  }

  /* ======================================================================
     3 · Rechnen — kennt kein DOM
     ====================================================================== */

  /* Der erste Sonderweg gilt. Mehr als einen kann es nicht geben: RAL und
     eingesendetes Material schliessen sich aus. */
  function sonderweg(z) {
    for (let i = 0; i < z.daten.ebenen.length; i++) {
      const art = sonderArt(gewaehlt(z, i));
      if (art) return { art, ebene: i, option: gewaehlt(z, i) };
    }
    return null;
  }

  function grundpreis(z, sonder) {
    if (!sonder) return z.daten.basis;
    return sonder.art === 'ral' ? z.daten.basis_ral : z.daten.basis_material;
  }

  function aufpreise(z, sonder) {
    return z.daten.ebenen.reduce((summe, ebene, i) => {
      // Beim Sonderweg traegt die mitlaufende Ebene dasselbe Material; ihr
      // Aufpreis steckt bereits im Grundpreis.
      if (sonder && ebene.folgt_furnier) return summe;
      return summe + (hat(gewaehlt(z, i), 'holz') ? ebene.aufpreis : 0);
    }, 0);
  }

  const werteListe = (z) => z.daten.ebenen.map((_, i) => (gewaehlt(z, i) || {}).wert || '');

  /* Trifft die Auswahl genau eine Katalog-Zusammenstellung, ist es nichts
     Individuelles — dann bekommt der Kunde das echte Produkt.

     Verglichen wird ueber die NAMEN der Ebenen, nicht ueber ihre Position:

         Gehäuse=Schwarz;Furnier unten=Schwarz glänzend;…

     Die erste Fassung zaehlte Positionen. Beim Umsortieren der Bloecke im
     Theme-Editor — eine Handbewegung — waere die Erkennung dann still
     falsch geworden und der Kunde haette 269 statt 229 gezahlt, ohne dass
     es jemandem auffaellt. Ein Name haelt das aus. */
  function katalogTreffer(z, sonder) {
    if (sonder) return null;
    const passend = z.daten.katalog.filter((k) => katalogPasst(z, k));
    return passend.length ? passend[0] : null;
  }

  /* Verglichen werden nur Ebenen, die der Kunde waehlt UND die zaehlen.
     Feste Ebenen haben keine Wahl, und die Kueche ist nur Vorschau — beide
     duerfen ueber Katalogware nicht mitentscheiden. */
  const zaehlt = (ebene) => ebene.optionen.length > 0 && !ebene.nur_vorschau;

  function katalogPasst(z, k) {
    const soll = paare(k.werte);
    const echte = z.daten.ebenen.map((e, i) => ({ e, i })).filter((x) => zaehlt(x.e));
    if (Object.keys(soll).length !== echte.length) return false;
    return echte.every((x) => soll[x.e.titel] === (gewaehlt(z, x.i) || {}).wert);
  }

  function paare(liste) {
    const aus = {};
    (liste || []).forEach((eintrag) => {
      const t = String(eintrag).split('=');
      if (t.length > 1) aus[t[0].trim()] = t.slice(1).join('=').trim();
    });
    return aus;
  }

  function varianteZuPreis(z, cent) {
    const passend = z.daten.varianten.filter((v) => v.preis === cent);
    return passend.length ? passend[0] : null;
  }

  /* Die eine Quelle der Wahrheit. Alles Weitere liest nur noch ab. */
  function auswahl(z) {
    const sonder = sonderweg(z);
    const katalog = katalogTreffer(z, sonder);
    const cent = katalog ? katalog.preis : grundpreis(z, sonder) + aufpreise(z, sonder);
    return {
      sonder,
      katalog,
      cent,
      variante: katalog || varianteZuPreis(z, cent),
      werte: werteListe(z),
    };
  }

  /* Welche Option bestimmt das Bild dieser Ebene? Bei RAL die
     naechstliegende Katalogfarbe, bei einer mitlaufenden Ebene die des
     Furniers, sonst schlicht die gewaehlte. */
  function bildOption(z, a, i) {
    const ebene = z.daten.ebenen[i];
    if (!ebene.optionen.length) return null;
    if (!a.sonder) return gewaehlt(z, i);
    if (a.sonder.ebene === i) return ersatzOption(z, ebene);
    if (!ebene.folgt_furnier) return gewaehlt(z, i);
    return gleichnamig(ebene, ersatzOption(z, z.daten.ebenen[a.sonder.ebene]));
  }

  /* Die fertige Adresse einer Ebene. Eine Ebene ohne Optionen waehlt nichts
     aus, sondern folgt anderen — sie hat statt Optionen ein Muster. */
  function ebenenBild(z, a, i) {
    const ebene = z.daten.ebenen[i];
    if (!ebene.optionen.length) return dateiAdresse(z, a, ebene.muster, ebene);
    const opt = bildOption(z, a, i);
    return opt ? dateiAdresse(z, a, opt.bild, ebene) : '';
  }

  /* Aus Dateiname wird Adresse. Die Sektion liefert den Ordner einmal mit;
     eine fertige `file_url` je Option gibt es nicht mehr, seit Dateinamen
     Platzhalter tragen koennen — welche Datei gemeint ist, steht erst fest,
     wenn der Kunde gewaehlt hat. */
  function dateiAdresse(z, a, muster, ebene) {
    if (!muster) return '';
    return (z.daten.basis_url || '') + einsetzen(muster, z, a, ebene);
  }

  /* Fuer einen Sonderweg gibt es kein Rendering der Kundenfarbe. Bei RAL
     steht die naechstliegende Katalogfarbe, sonst die erste — eine leere
     Ebene saehe aus wie ein fehlendes Bauteil. */
  function ersatzOption(z, ebene) {
    const weg = sonderweg(z);
    const naeherung = weg && weg.art === 'ral' ? z.ral.treffer : null;
    return naeherung || ebene.optionen.filter((o) => !istSonder(o))[0] || null;
  }
  /* ======================================================================
     4 · RAL nachschlagen
     ---------------------------------------------------------------------
     Drei RAL-Sammlungen werden erkannt — die Nummer geht IMMER genau so
     in die Bestellung, wie sie erkannt wurde. Vorher las das Feld nur die
     ersten vier Ziffern: aus „RAL 210 50 15" wurde still „RAL 2105".

       CLASSIC  7016          -> Farbwert aus assets/ug-ral.json
       DESIGN   210 50 15     -> Farbwert BERECHNET: der Code ist selbst
                                 die Farbe (Farbton, Helligkeit, Buntheit
                                 in CIELab, D65/10°). Keine Tabelle noetig.
       EFFECT   110-1, 110-M  -> GRUNDTON aus assets/ug-ral.json („effect"),
                                 ohne Metallic/Effekt — der laesst sich
                                 nicht darstellen. Grobe Orientierung.

     Alles andere geht als „Kundeneingabe" woertlich in die Bestellung.
     ====================================================================== */

  const RAL_LEER = { eingabe: '', art: '', nummer: '', name: '', hex: '', treffer: null };
  let ralTabelle = null;
  let ralLaeuft = null;

  function ralHolen(quelle) {
    if (ralTabelle) return Promise.resolve(ralTabelle);
    if (!ralLaeuft) {
      ralLaeuft = fetch(quelle)
        .then((a) => a.json())
        .then((d) => (ralTabelle = { classic: d.farben || {}, effect: d.effect || {} }))
        .catch(() => (ralTabelle = { classic: {}, effect: {} }));
    }
    return ralLaeuft;
  }

  /* "RAL 7016" -> classic 7016 · "210 50 15" / "2105015" -> design ·
     "110-M" / "RAL Effect 110-1" -> effect · sonst null */
  function ralLesen(text) {
    const t = String(text || '').trim().toLowerCase().replace(/^ral\s*/, '').replace(/^(effect|design|classic)\s*/, '');
    let m = t.match(/^(\d{4})$/);
    if (m) return { art: 'classic', nummer: m[1] };
    m = t.match(/^(\d{3})[\s.\-/]*(\d{2})[\s.\-/]*(\d{2})$/);
    if (m && Number(m[1]) <= 360) return { art: 'design', nummer: m[1] + ' ' + m[2] + ' ' + m[3], h: +m[1], l: +m[2], c: +m[3] };
    m = t.match(/^(\d{3})\s*-\s*([1-6m])$/);
    if (m) return { art: 'effect', nummer: m[1] + '-' + m[2].toUpperCase() };
    return null;
  }

  /* RAL DESIGN: LCh (D65, 10°) -> Lab -> XYZ -> sRGB. Der Weissbezug wird
     vom 10°- auf den 2°-Beobachter umgerechnet, den sRGB voraussetzt.
     Farben ausserhalb dessen, was ein Bildschirm kann, werden gekappt. */
  function lchZuHex(l, c, h) {
    const rad = (h * Math.PI) / 180;
    const a = c * Math.cos(rad);
    const b = c * Math.sin(rad);
    const fy = (l + 16) / 116;
    const fx = fy + a / 500;
    const fz = fy - b / 200;
    const inv = (f) => (f * f * f > 0.008856 ? f * f * f : (f - 16 / 116) / 7.787);
    // Weisspunkt D65/10° -> auf D65/2° skaliert
    const x = inv(fx) * 0.94811 * (0.95047 / 0.94811);
    const y = inv(fy) * 1.0;
    const z = inv(fz) * 1.07304 * (1.08883 / 1.07304);
    const lin = [
      x * 3.2406 + y * -1.5372 + z * -0.4986,
      x * -0.9689 + y * 1.8758 + z * 0.0415,
      x * 0.0557 + y * -0.2040 + z * 1.0570,
    ];
    return '#' + lin
      .map((v) => (v > 0.0031308 ? 1.055 * Math.pow(v, 1 / 2.4) - 0.055 : 12.92 * v))
      .map((v) => Math.round(Math.min(1, Math.max(0, v)) * 255).toString(16).padStart(2, '0'))
      .join('').toUpperCase();
  }

  function ralPruefen(z) {
    const eingabe = z.ral.eingabe;
    const gelesen = ralLesen(eingabe);
    if (!gelesen) {
      z.ral = Object.assign({}, RAL_LEER, { eingabe });
      aktualisieren(z);
      return;
    }
    if (gelesen.art === 'design') {
      z.ral = ralErgebnis(z, gelesen, { hex: lchZuHex(gelesen.l, gelesen.c, gelesen.h), name: '' });
      aktualisieren(z);
      return;
    }
    ralHolen(z.daten.ral_quelle).then((tabelle) => {
      // Zwischenzeitlich weitergetippt? Dann gilt die neuere Eingabe.
      const jetzt = ralLesen(z.ral.eingabe);
      if (!jetzt || jetzt.nummer !== gelesen.nummer) return;
      z.ral = ralErgebnis(z, gelesen, tabelle[gelesen.art][gelesen.nummer]);
      aktualisieren(z);
    });
  }

  function ralErgebnis(z, gelesen, eintrag) {
    const basis = { eingabe: z.ral.eingabe, art: gelesen.art, nummer: gelesen.nummer, name: '', hex: '', treffer: null };
    const sonder = sonderweg(z);
    if (!eintrag || !eintrag.hex || !sonder) return basis;
    return Object.assign(basis, {
      name: eintrag.name || '',
      hex: eintrag.hex,
      treffer: naechsteOption(z.daten.ebenen[sonder.ebene], eintrag.hex),
    });
  }
  /* ======================================================================
     5 · Anzeigen — jede Funktion schreibt an genau eine Stelle
     ====================================================================== */

  /* `glatt`: bei runden Betraegen die Nachkommastellen weglassen. Am
     Gesamtpreis gehoeren sie hin — dort steht eine Summe, die auch krumm
     sein kann. An einer Kachel ist „+15,00 €" nur Ballast; „+15 €" liest
     sich in einem Viertel der Zeit. */
  function geld(cent, waehrung, glatt) {
    const rund = glatt && cent % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: waehrung || 'EUR',
        minimumFractionDigits: rund ? 0 : 2,
        maximumFractionDigits: rund ? 0 : 2,
      }).format(cent / 100);
    } catch (e) {
      return rund ? String(cent / 100) : (cent / 100).toFixed(2);
    }
  }

  const gruppe = (z, i) => z.wurzel.querySelector('[data-ug-konf-gruppe="' + i + '"]');
  const teil = (z, name) => z.wurzel.querySelector('[data-ug-konf-' + name + ']');

  function zeigeEbenen(z, a) {
    z.daten.ebenen.forEach((ebene, i) => {
      const g = gruppe(z, i);
      if (g) zeigeEbene(z, a, ebene, i, g);
    });
  }

  function zeigeEbene(z, a, ebene, i, g) {
    const gesperrt = !!a.sonder && !!ebene.folgt_furnier;
    g.classList.toggle('ug-konf__ebene-wahl--gesperrt', gesperrt);
    g.querySelectorAll('.ug-konf__feld').forEach((f) => (f.disabled = gesperrt));
    // Eine Ebene, an der nichts mehr zu waehlen ist, bleibt zu.
    if (gesperrt) g.open = false;

    /* Die Felder auf den Zustand nachziehen.

       Noetig, weil eine Ebene sich aendern kann, ohne dass jemand sie
       angeklickt hat: waehlt man beim Gehaeuse Salbei, zieht `mitziehen`
       die Blende an der Lampe mit. Im Bild und in der zugeklappten Zeile
       stand das sofort richtig — im aufgeklappten Formular blieb der alte
       Haken stehen. Das Formular behauptete dann etwas anderes als das
       Bild daneben, und wer die Blende danach anfasste, hatte den
       Eindruck, seine Wahl sei verlorengegangen.

       Geklammert wie in `gewaehlt`: hat eine Ebene weniger Optionen als
       die, von der sie mitgezogen wurde, zeigt sie die letzte. */
    const gewaehltJ = Math.min(z.wahl[i], ebene.optionen.length - 1);
    g.querySelectorAll('.ug-konf__feld').forEach((f) => {
      const soll = Number(f.value) === gewaehltJ;
      if (f.checked !== soll) f.checked = soll;
    });

    const anzeige = g.querySelector('[data-ug-konf-wert]');
    if (anzeige) anzeige.textContent = gesperrt ? ugT('konf_wie_furnier', 'wie Furnier') : a.werte[i];

    const punkt = g.querySelector('[data-ug-konf-probe-ebene]');
    if (punkt) punkt.style.backgroundColor = kopfFarbe(z, a, i) || 'transparent';
  }

  /* Der Punkt in der zugeklappten Zeile zeigt dieselbe Option wie die
     Vorschau — sonst behauptet die Zeile etwas anderes als das Bild. Bei
     einer eigenen RAL-Farbe steht dort der echte RAL-Wert, nicht die
     Naeherung: an dieser Stelle ist es eine Bestaetigung der Eingabe. */
  function kopfFarbe(z, a, i) {
    if (a.sonder && a.sonder.ebene === i && z.ral.hex) return z.ral.hex;
    const opt = bildOption(z, a, i);
    return (opt && opt.farbe) || '';
  }

  /* Der Preis der Variante IST der Preis der laufenden Charge — das Geraet
     kostet in Batch 2 wirklich 179. Daneben steht der Listenpreis, also der
     Preis nach der Charge (229), durchgestrichen.

     Warum nicht ueber einen Rabatt: Ein Produktrabatt auf dem Geraet sperrt
     die Gratis-Schere (Shopify laesst Kaufe-X-Artikel keine weiteren
     Produktrabatte tragen), und ein Bestellrabatt gilt nur einmal je
     Bestellung, skaliert also nicht mit der Menge. Beides gemessen.

     Der Aufschlag kommt aus der Sektionseinstellung; steht dort 0, gibt es
     keinen Streichpreis. */
  function zeigePreis(z, a) {
    const aufschlag = z.daten.aufschlag || 0;

    const feld = teil(z, 'preis');
    if (feld) feld.textContent = geld(a.cent, z.daten.waehrung);

    const alt = teil(z, 'preis-alt');
    if (!alt) return;
    if (aufschlag > 0) {
      alt.textContent = geld(a.cent + aufschlag, z.daten.waehrung);
      alt.hidden = false;
    } else {
      alt.textContent = '';
      alt.hidden = true;
    }
  }

  /* Die Zusammenstellung in einer Zeile je Gruppe:

       Korpus   Schwarz · Nussbaum · Acrylglas
       Lampe    Schwarz · Nussbaum

     Gruppiert und nicht als lange Aufzaehlung: sechs Werte hintereinander
     sind eine Kette, drei und zwei sind zwei Gedanken. Ebenen ohne Gruppe
     und reine Vorschau-Ebenen bleiben draussen — die Kueche wird nicht
     mitgeliefert. */
  function zeigeUebersicht(z, a) {
    const feld = teil(z, 'uebersicht');
    if (!feld) return;

    const gruppen = [];
    z.daten.ebenen.forEach((ebene, i) => {
      if (!ebene.optionen.length || ebene.nur_vorschau || !ebene.gruppe) return;
      const wert = a.sonder && ebene.folgt_furnier ? ugT('konf_wie_verkleidung', 'wie Verkleidung') : a.werte[i];
      if (!wert) return;
      let g = gruppen.find((x) => x.name === ebene.gruppe);
      if (!g) {
        g = { name: ebene.gruppe, werte: [] };
        gruppen.push(g);
      }
      g.werte.push(wert);
    });

    feld.innerHTML = '';
    gruppen.forEach((g) => {
      const dt = document.createElement('dt');
      dt.textContent = g.name;
      const dd = document.createElement('dd');
      dd.textContent = g.werte.join(' · ');
      feld.appendChild(dt);
      feld.appendChild(dd);
    });
  }

  function zeigeKnopf(z, a) {
    const kaufbar = !!a.variante && a.variante.verfuegbar !== false;
    const feld = teil(z, 'id');
    const knopf = teil(z, 'knopf');
    const text = teil(z, 'knopf-text');
    if (feld) feld.value = a.variante ? String(a.variante.id) : '';
    if (knopf) knopf.disabled = !kaufbar;
    if (text) text.textContent = knopfText(text, a, kaufbar);
  }

  function knopfText(text, a, kaufbar) {
    if (kaufbar) return text.dataset.ugStandard || text.textContent;
    return a.variante
      ? ugT('konf_nicht_verfuegbar', 'Zurzeit nicht verfügbar')
      : ugT('konf_nicht_bestellbar', 'Diese Kombination ist nicht bestellbar');
  }

  /* Die Eingabe steht in der Ebene, in der geklickt wurde — nicht am Ende
     der Tafel. Wer "Eigene RAL-Farbe" antippt, erwartet das Feld dort, wo er
     getippt hat. */
  function zeigeSonderfeld(z, a) {
    z.wurzel.querySelectorAll('[data-ug-konf-sonder]').forEach((kasten) => {
      const i = Number(kasten.closest('[data-ug-konf-gruppe]').dataset.ugKonfGruppe);
      const dran = !!a.sonder && a.sonder.ebene === i;
      if (!dran) return sonderfeldLeeren(kasten);
      sonderfeldBauen(z, kasten, a.sonder.art);
      if (a.sonder.art === 'ral') ralAntwort(z, kasten);
    });
  }

  function sonderfeldLeeren(kasten) {
    if (kasten.hidden) return;
    kasten.hidden = true;
    kasten.innerHTML = '';
    /* Muss mit weg. Bleibt die Merkung stehen, gilt das Feld beim
       Zurueckkommen als "schon gebaut" — und der Kasten waere leer. */
    delete kasten.dataset.ugArt;
  }

  function sonderfeldBauen(z, kasten, art) {
    kasten.hidden = false;
    if (kasten.dataset.ugArt === art) return;
    kasten.dataset.ugArt = art;
    kasten.innerHTML = art === 'ral' ? VORLAGE_RAL : VORLAGE_MATERIAL;
    /* Was schon eingegeben war, kommt zurueck: wer versehentlich eine Farbe
       antippt, soll seine Nummer nicht neu tippen muessen. */
    const feld = kasten.querySelector('input');
    if (feld) feld.value = art === 'ral' ? z.ral.eingabe : z.material;
  }

  function ralAntwort(z, kasten) {
    const probe = kasten.querySelector('[data-ug-konf-probe]');
    const antwort = kasten.querySelector('[data-ug-konf-antwort]');
    if (!antwort) return;
    const befund = ralText(z);
    antwort.textContent = befund.text;
    antwort.classList.toggle('ug-konf__sonder-antwort--fehlt', befund.fehlt);
    if (probe) probe.style.backgroundColor = z.ral.hex || 'transparent';
  }

    function ralText(z) {
    if (!z.ral.art) {
      return z.ral.eingabe.trim()
        ? { text: ugT('konf_ral_format', 'Bitte als RAL-Nummer eingeben, z. B. 7016, 210 50 15 oder 110-M.'), fehlt: true }
        : { text: ugT('konf_ral_mischen', 'Wir mischen deinen Farbton nach RAL.'), fehlt: false };
    }
    if (z.ral.art === 'effect') {
      return {
        text: 'RAL Effect ' + z.ral.nummer + ' · ' + (z.ral.hex
          ? ugT('konf_ral_effekt', 'Grundton ohne Effekt, der Lack wirkt in echt anders.')
          : ugT('konf_ral_effekt_fehlt', 'Den Grundton kennen wir nicht, gefertigt wird exakt nach dieser Nummer.')),
        fehlt: false,
      };
    }
    if (!z.ral.hex) {
      return {
        text: ugT('konf_ral_unbekannt', 'RAL {nummer} kennen wir hier nicht. Bestellen kannst du sie trotzdem, die Vorschau bleibt dann beim Standard.', { nummer: z.ral.nummer }),
        fehlt: true,
      };
    }
    const bez = z.ral.art === 'design' ? 'RAL Design ' + z.ral.nummer : 'RAL ' + z.ral.nummer + (z.ral.name ? ' · ' + z.ral.name : '');
    return { text: bez, fehlt: false };
  }

  /* =========================================================================
     Eigene RAL-Farbe im Produktbild
     Verkleidung und Blende werden im hellsten Standardton (Salz) geladen und
     mit einer Farbschicht im RAL-Ton ueberzogen: gleiche Form (Maske = das
     Ebenenbild selbst), Multiplizieren, damit Licht und Schatten des Renders
     erhalten bleiben. Der Ton wird vorher um die Eigenfarbe von Salz
     aufgehellt, sonst waere jede RAL-Farbe rund 25 % zu dunkel.
     Warenkorbbild (_ebenen) bleibt bei der naechstliegenden Katalogfarbe.
     ========================================================================= */
  function ralTon(z, a) {
    return a.sonder && a.sonder.art === 'ral' && z.ral.hex ? z.ral.hex : '';
  }

  function wirdGefaerbt(z, a, i) {
    return !!ralTon(z, a) && (a.sonder.ebene === i || !!z.daten.ebenen[i].folgt_furnier);
  }

  // Hellste Standardfarbe der Ebene (Holz und Sonderwege ausgenommen) = Salz.
  function neutraleOption(ebene) {
    let beste = null, hellste = -1;
    ebene.optionen.forEach((o) => {
      if (istSonder(o) || hat(o, 'holz')) return;
      const lab = labVon(o.farbe);
      if (lab && lab[0] > hellste) { hellste = lab[0]; beste = o; }
    });
    return beste;
  }

  function tonQuelle(z, a, i) {
    if (!wirdGefaerbt(z, a, i)) return '';
    const ebene = z.daten.ebenen[i];
    const opt = neutraleOption(ebene);
    return opt ? dateiAdresse(z, a, opt.bild, ebene) : '';
  }

  // RAL-Ton durch die Eigenfarbe der hellen Vorlage teilen (je Kanal, max. 255).
  function tonFuer(z, a, i) {
    const ziel = hexZuRgb(ralTon(z, a));
    const opt = neutraleOption(z.daten.ebenen[i]);
    const bezug = hexZuRgb(opt && opt.farbe) || [255, 255, 255];
    if (!ziel) return '';
    return '#' + ziel.map((k, n) => Math.min(255, Math.round(k * 255 / Math.max(bezug[n], 1))).toString(16).padStart(2, '0')).join('');
  }

  function tonSchicht(bild) {
    let t = bild.nextElementSibling;
    if (!t || !t.classList.contains('ug-konf__ton')) {
      t = document.createElement('span');
      t.className = 'ug-konf__ton';
      t.setAttribute('aria-hidden', 'true');
      t.hidden = true;
      bild.after(t);
    }
    return t;
  }

  // Schicht erst zeigen, wenn das Bild darunter wirklich die helle Vorlage ist.
  function tonAbgleichen(bild) {
    const ton = bild.dataset.ugTon || '';
    if (!ton && !(bild.nextElementSibling && bild.nextElementSibling.classList.contains('ug-konf__ton'))) return;
    const t = tonSchicht(bild);
    const bereit = !!ton && !bild.hidden && bild.getAttribute('src') === bild.dataset.ugZiel;
    t.hidden = !bereit;
    if (!bereit) return;
    const maske = 'url("' + bild.dataset.ugZiel + '")';
    t.style.zIndex = bild.style.zIndex;
    t.style.backgroundColor = ton;
    t.style.webkitMaskImage = maske;
    t.style.maskImage = maske;
  }

  function zeigeTon(z, a) {
    z.daten.ebenen.forEach((_, i) => {
      const bild = z.wurzel.querySelector('[data-ug-konf-ebene="' + i + '"]');
      if (!bild) return;
      bild.dataset.ugTon = wirdGefaerbt(z, a, i) ? tonFuer(z, a, i) : '';
      tonAbgleichen(bild);
    });
  }

  // Ebenen fuer das Vorschaubild an der Bestellung, mit Farbton.
  function vorschauEbenen(z, a) {
    const ebenen = z.daten.ebenen
      .map((ebene, i) => ({
        stapel: ebene.stapel || 0,
        bild: tonQuelle(z, a, i) || ebenenBild(z, a, i),
        ton: wirdGefaerbt(z, a, i) ? tonFuer(z, a, i) : '',
      }))
      .filter((x) => x.bild)
      .sort((x, y) => x.stapel - y.stapel);
    const vorne = z.daten.hintergrund ? [{ bild: z.daten.hintergrund, ton: '' }] : [];
    const hinten = z.daten.vordergrund ? [{ bild: z.daten.vordergrund, ton: '' }] : [];
    return vorne.concat(ebenen, hinten);
  }

  /* Ebenen werden VORGELADEN und erst beim Gelingen getauscht. Zwei Gruende:
     ein halb geladenes Bild blitzt sonst auf, und `file_url` liefert auch
     dann eine Adresse, wenn die Datei in Shopify gar nicht liegt — ohne die
     Bremse staende dort ein zerbrochenes Bildsymbol.

     Die Ebene wird dabei NICHT versteckt. Das war die Ursache dafuer, dass
     die Seite beim Herumklicken sprang. */
  /* Die hinterste Ebene zuerst, der Rest wartet auf sie.

     Auf einem schmalen Netz laden sonst Kueche und zehn Bauteile
     gleichzeitig, und der Browser gibt hoechstens sechs Verbindungen her.
     Kommt das Gehaeuse vor der Kueche an, steht es einen Moment auf
     weissem Grund — es sieht kaputt aus, obwohl nur die Reihenfolge
     unguenstig ist.

     „Hinterste" ueber die Einstellung „Position im Bild", nicht
     festverdrahtet auf die Kueche: wer im Editor umsortiert, soll nicht
     noch eine zweite Stelle anfassen muessen. */
  const HINTERGRUND_GEDULD = 8000;

  function hinterste(z) {
    let tiefste = -1;
    let tief = Infinity;
    z.daten.ebenen.forEach((ebene, i) => {
      const s = ebene.stapel || 0;
      if (s < tief) { tief = s; tiefste = i; }
    });
    return tiefste;
  }

  function ebenenAuftrag(z, a, i) {
    const bild = z.wurzel.querySelector('[data-ug-konf-ebene="' + i + '"]');
    if (!bild) return null;
        const quelle = tonQuelle(z, a, i) || ebenenBild(z, a, i);
    if (!quelle || bild.dataset.ugZiel === quelle) return null;
    /* Das Ziel sofort vermerken, nicht erst beim Laden: klickt jemand
       waehrend des Wartens weiter, erkennt `bildSetzen` das veraltete
       Bild und laesst es liegen. */
    bild.dataset.ugZiel = quelle;
    return (weiter) => vorladen(quelle, () => bildSetzen(bild, quelle), weiter);
  }

  function zeigeVorschau(z, a) {
    const grund = hinterste(z);
    const auftraege = [];
    z.daten.ebenen.forEach((_, i) => {
      const auftrag = ebenenAuftrag(z, a, i);
      if (auftrag) auftraege.push({ i, auftrag });
    });
    if (!auftraege.length) return;

    const hinten = auftraege.find((x) => x.i === grund);
    const rest = auftraege.filter((x) => x.i !== grund).map((x) => x.auftrag);
    const losLegen = () => rest.forEach((f) => f());

    // Steht der Grund schon, oder aendert er sich gerade nicht: alles sofort.
    if (!hinten || z.grundGeladen) {
      if (hinten) hinten.auftrag(() => { z.grundGeladen = true; });
      losLegen();
      return;
    }

    /* Das Zeitfenster ist die Notbremse: kommt der Grund gar nicht, waere
       eine leere Buehne schlimmer als ein Bauteil ohne Kueche dahinter. */
    let schon = false;
    const einmal = () => { if (!schon) { schon = true; losLegen(); } };
    hinten.auftrag(() => { z.grundGeladen = true; einmal(); });
    setTimeout(einmal, HINTERGRUND_GEDULD);
  }

  /* Erst laden, dann tauschen: so springt die Ebene nicht kurz auf leer.
     Laedt die Datei nicht, bleibt die alte stehen — besser ein veraltetes
     Bauteil als ein Loch im Geraet.

     Der Haken daran: eine fehlende Datei faellt niemandem auf. Deshalb die
     Meldung — sie kostet nichts und beantwortet beim naechsten Mal in einer
     Zeile, was sonst eine halbe Stunde Suche ist. */
  function vorladen(quelle, fertig, weiter) {
    const probe = new Image();
    probe.onload = () => {
      fertig();
      if (weiter) weiter();
    };
    probe.onerror = () => {
      if (window.console) console.warn('Konfigurator: Bild fehlt —', quelle);
      // Auch dann weiter: an einer fehlenden Datei darf nichts haengen bleiben.
      if (weiter) weiter();
    };
    probe.src = quelle;
  }

    function bildSetzen(bild, quelle) {
    // Zwischenzeitlich weitergeklickt? Dann gilt die neuere Wahl.
    if (bild.dataset.ugZiel !== quelle) return;
    bild.src = quelle;
    bild.hidden = false;
    tonAbgleichen(bild);
  }

  function zeigeEigenschaften(z, a) {
    const behaelter = teil(z, 'eigenschaften');
    if (!behaelter) return;
    behaelter.innerHTML = '';
    // Bei Katalogware beschreibt das Produkt sich selbst.
    if (a.katalog) return;

    /* Kennzeichen fuer den Warenkorb: bei dieser Zeile ist der
       Variantenname ("Konfiguration: Custom-Made 2") nur ein Preistraeger
       und sagt dem Kunden nichts. Der Unterstrich ist Shopifys Kennzeichen
       fuer "geht den Kunden nichts an" — die Eigenschaft wird nirgends
       angezeigt. Siehe 00_tools/variante-im-warenkorb-verbergen.js. */
    behaelter.appendChild(feld('properties[_quelle]', 'Konfigurator'));
    behaelter.appendChild(feld('properties[_variante_verbergen]', '1'));

    /* Die Ebenen fuer das Bild im Warenkorb, in Stapelreihenfolge. Das
       Snippet ug-warenkorb-bild legt sie dort ueber das Produktfoto, damit
       der Kunde sein Geraet sieht und nicht das Vorschaubild.

       Adressen und nicht Dateinamen: so braucht die Warenkorbseite die
       Zuordnung von Farbe zu Datei nicht zu kennen — die steht nur in den
       Einstellungen dieser Sektion. */
    const bilder = ebenenBilder(z, a);
    if (bilder.length) behaelter.appendChild(feld('properties[_ebenen]', bilder.join('|')));

    z.daten.ebenen.forEach((ebene, i) => {
      if (!zaehlt(ebene)) return;
      const wert = a.sonder && ebene.folgt_furnier ? 'wie Furnier' : a.werte[i]; // Bestelldaten: bleibt deutsch, der Versand liest es.
      if (wert) behaelter.appendChild(feld('properties[' + ebene.titel + ']', wert));
    });
    zusatzEigenschaft(z, a).forEach((f) => behaelter.appendChild(f));
    behaelter.appendChild(feld('properties[_zurueck]', zurueckAdresse(z, a)));

    /* Zuletzt, und mit Verzoegerung: das `innerHTML = ''` oben hat das
       Dateifeld gerade mitgenommen. Damit kann nie ein Bild von einer
       aelteren Auswahl mitgeschickt werden — hoechstens gar keines. */
    vorschauPlanen(z, a);
  }

  /* Fuer das Bild im Warenkorb: von hinten nach vorn, nach der Einstellung
     "Position im Bild" — NICHT nach der Reihenfolge der Bloecke. Die
     bestimmt nur, in welcher Reihenfolge man waehlt. */
  function ebenenBilder(z, a) {
    const ebenen = z.daten.ebenen
      .map((ebene, i) => ({ stapel: ebene.stapel || 0, bild: ebenenBild(z, a, i) }))
      .filter((x) => x.bild)
      .sort((x, y) => x.stapel - y.stapel)
      .map((x) => x.bild);
    /* Der Hintergrund muss mit: er deckt das Produktfoto ab, das im Warenkorb
       unter dem Ueberzug liegt und sonst durch die durchsichtigen Stellen
       scheint. */
    const stapel = z.daten.hintergrund ? [z.daten.hintergrund].concat(ebenen) : ebenen;
    return z.daten.vordergrund ? stapel.concat([z.daten.vordergrund]) : stapel;
  }

    function zusatzEigenschaft(z, a) {
    if (!a.sonder) return [];
    if (a.sonder.art === 'ral' && z.ral.eingabe.trim()) {
      /* Die Nummer geht GENAU so in die Bestellung, wie sie erkannt wurde —
         mit Sammlung, damit die Fertigung nicht raten muss. Nicht
         erkannte Eingaben woertlich. */
      const vorsatz = { classic: 'RAL ', design: 'RAL Design ', effect: 'RAL Effect ' }[z.ral.art];
      const name = z.ral.name ? ' (' + z.ral.name + ')' : '';
      const wert = vorsatz ? vorsatz + z.ral.nummer + name : 'Kundeneingabe: ' + z.ral.eingabe.trim();
      return [feld('properties[RAL-Farbe]', wert)];
    }
    if (a.sonder.art === 'material' && z.material.trim()) {
      return [feld('properties[Material]', z.material.trim())];
    }
    return [];
  }

  function feld(name, wert) {
    const f = document.createElement('input');
    f.type = 'hidden';
    f.name = name;
    f.value = wert;
    return f;
  }

  /* ---- Zurueck aus dem Warenkorb --------------------------------------
     Wer im Warenkorb auf seine Konfiguration klickt, landete bisher auf
     der nackten Produktseite bei einer Variante namens „Custom-Made 2" —
     einer Preisstufe, mit der niemand etwas anfangen kann. Die Zeile
     merkt sich stattdessen die Adresse dieser Seite samt Auswahl.

     Verglichen wird ueber den NAMEN der Option, nicht ueber ihre Position.
     Sonst zeigte eine gemerkte Adresse nach dem Umsortieren der Farben im
     Theme-Editor auf etwas anderes — und niemand kaeme darauf, woran es
     liegt. Denselben Grund hat `mitziehen` weiter oben.

     Die Sonderwege bekommen einen Unterstrich vorweg (`_ral`, `_mat`),
     damit sie nie mit dem Schluessel einer Ebene zusammenfallen. */
  function zurueckAdresse(z, a) {
    const teile = [];
    z.daten.ebenen.forEach((ebene, i) => {
      if (!zaehlt(ebene) || !ebene.schluessel || !a.werte[i]) return;
      teile.push(ebene.schluessel + ':' + encodeURIComponent(a.werte[i]));
    });
    if (a.sonder && a.sonder.art === 'ral' && z.ral.eingabe) {
      teile.push('_ral:' + encodeURIComponent(z.ral.eingabe));
    }
    if (a.sonder && a.sonder.art === 'material' && z.material.trim()) {
      teile.push('_mat:' + encodeURIComponent(z.material.trim()));
    }
    return window.location.pathname + '?k=' + teile.join(',');
  }

  function ausAdresse(z) {
    let roh = '';
    try {
      roh = new URLSearchParams(window.location.search).get('k') || '';
    } catch (e) {
      return;
    }
    if (!roh) return;

    const paare = {};
    roh.split(',').forEach((stueck) => {
      const t = stueck.split(':');
      if (t.length > 1) paare[t[0]] = decodeURIComponent(t.slice(1).join(':'));
    });

    z.daten.ebenen.forEach((ebene, i) => {
      const wert = paare[ebene.schluessel];
      if (!wert) return;
      const j = ebene.optionen.findIndex((o) => o.wert === wert);
      if (j !== -1) z.wahl[i] = j;
    });
    if (paare._ral) z.ral = Object.assign({}, z.ral, { eingabe: paare._ral });
    if (paare._mat) z.material = paare._mat;
  }

  /* Die beiden Textfelder entstehen erst beim Anzeigen — vorher gibt es
     nichts zu befuellen. Deshalb hier und nicht in `ausAdresse`. */
  function sonderfeldFuellen(z) {
    const ral = teil(z, 'ral');
    if (ral && z.ral.eingabe) {
      ral.value = z.ral.eingabe;
      ralPruefen(z);
    }
    const material = teil(z, 'material');
    if (material && z.material) {
      material.value = z.material;
      aktualisieren(z);
    }
  }

  /* ---- Vorschaubild der Konfiguration ---------------------------------
     Der Kunde soll in der Bestaetigung sehen, was er gebaut hat, und die
     Fertigung soll es in der Bestellung sehen. Dafuer werden die Ebenen
     auf eine Leinwand gezeichnet und als Datei an die Warenkorbzeile
     gehaengt; Shopify legt sie unter /uploads/ ab und macht die Adresse
     zum Wert der Eigenschaft.

     ZWEI ENTSCHEIDUNGEN, DAMIT DAVON KEIN KAUF ABHAENGT:

     1. Das Bild entsteht IM HINTERGRUND bei jeder Aenderung — nicht beim
        Klick auf „In den Warenkorb". Waere es andersherum, haenge der
        Kauf an einer Leinwand, elf Bildabrufen und einer Umwandlung.
     2. Das Dateifeld wird nur angelegt, wenn ein Bild fertig ist. Geht
        unterwegs etwas schief, fehlt es einfach und alles andere
        funktioniert wie vorher.

     Abschaltbar im Theme-Editor („Vorschaubild an die Bestellung
     haengen"). Ausgeschaltet passiert hier gar nichts. */
  const VORSCHAU_KANTE = 1200;
  const VORSCHAU_WARTEN = 600;
  let vorschauLauf = 0;

  function vorschauPlanen(z, a) {
    if (!z.daten.vorschau) return;
    clearTimeout(z.vorschauUhr);
    z.vorschauUhr = setTimeout(() => vorschauBauen(z, a), VORSCHAU_WARTEN);
  }

    function vorschauBauen(z, a) {
    const lauf = ++vorschauLauf;
    const ebenen = vorschauEbenen(z, a);
    if (!ebenen.length) return;
    Promise.all(ebenen.map((e) => ladeBild(e.bild)))
      .then((bilder) => (lauf === vorschauLauf ? zeichneEbenen(bilder, ebenen.map((e) => e.ton)) : null))
      .then((blob) => {
        if (blob && lauf === vorschauLauf) vorschauAnhaengen(z, blob);
      })
      .catch((e) => {
        if (window.console) console.warn('Konfigurator: kein Vorschaubild —', e);
      });
  }

  /* `crossOrigin` ist der Punkt, an dem es sonst scheitert: ohne das
     gilt die Leinwand als fremdbestueckt und `toBlob` wirft. Die Bilder
     liegen auf Shopifys CDN, das den Zugriff erlaubt. */
  function ladeBild(quelle) {
    return new Promise((fertig, fehler) => {
      const b = new Image();
      b.crossOrigin = 'anonymous';
      b.onload = () => fertig(b);
      b.onerror = () => fehler(new Error('Bild fehlt: ' + quelle));
      b.src = quelle;
    });
  }

  /* Die Ebenen sind 16:9 (2400x1350), die Vorschau ist quadratisch. Erst
     wurde jede Ebene schlicht auf die Kantenlaenge gezogen — das Geraet
     stand dann schmaler und hoeher da, als es ist.

     Jetzt wird die Mitte quadratisch herausgeschnitten, statt zu stauchen.
     Es ist derselbe Ausschnitt, den der Warenkorb ueber CSS zeigt
     (`object-fit: cover`, `object-position: 50% 50%`) — Warenkorb und
     Bestaetigung zeigen so dasselbe Bild. */
    function zeichneEbenen(bilder, toene) {
    const leinwand = document.createElement('canvas');
    leinwand.width = VORSCHAU_KANTE;
    leinwand.height = VORSCHAU_KANTE;
    const stift = leinwand.getContext('2d');
    bilder.forEach((b, n) => {
      const kante = Math.min(b.naturalWidth, b.naturalHeight);
      const ausschnitt = [(b.naturalWidth - kante) / 2, (b.naturalHeight - kante) / 2, kante, kante, 0, 0, VORSCHAU_KANTE, VORSCHAU_KANTE];
      const ton = toene && toene[n];
      if (!ton) {
        stift.drawImage(b, ...ausschnitt);
        return;
      }
      // Eigene RAL-Farbe: Ebene einfaerben (multiplizieren), dann auf ihre Form zuschneiden.
      const lage = document.createElement('canvas');
      lage.width = VORSCHAU_KANTE;
      lage.height = VORSCHAU_KANTE;
      const pinsel = lage.getContext('2d');
      pinsel.drawImage(b, ...ausschnitt);
      pinsel.globalCompositeOperation = 'multiply';
      pinsel.fillStyle = ton;
      pinsel.fillRect(0, 0, VORSCHAU_KANTE, VORSCHAU_KANTE);
      pinsel.globalCompositeOperation = 'destination-in';
      pinsel.drawImage(b, ...ausschnitt);
      stift.drawImage(lage, 0, 0);
    });
    return new Promise((fertig) => leinwand.toBlob(fertig, 'image/png'));
  }

  function vorschauAnhaengen(z, blob) {
    const behaelter = teil(z, 'eigenschaften');
    if (!behaelter || typeof DataTransfer !== 'function') return;
    const alt = behaelter.querySelector('input[type="file"]');
    if (alt) alt.remove();
    const f = document.createElement('input');
    f.type = 'file';
    /* Unterstrich davor: Shopify zeigt solche Eigenschaften dem Kunden
       nirgends an. Ohne ihn stand im Warenkorb und im Checkout eine nackte
       CDN-Adresse als Link — die will dort niemand sehen und anklicken
       schon gar nicht. Die Bestaetigungsmail holt das Bild gezielt hervor;
       das ist der einzige Ort, an dem es hingehoert. */
    f.name = 'properties[_Vorschau]';
    const post = new DataTransfer();
    post.items.add(new File([blob], 'konfiguration.png', { type: 'image/png' }));
    f.files = post.files;
    behaelter.appendChild(f);
  }

  /* Nur im Theme-Editor. Ein doppelter Preis macht die Zuordnung
     mehrdeutig — im Shop faellt das niemandem auf, weil dann einfach die
     falsche Variante im Warenkorb landet. */
  function zeigeWarnung(z, a) {
    const kasten = teil(z, 'warnung');
    if (!kasten || !EDITOR) return;
    const meldungen = doppeltePreise(z).map(
      (cent) => 'Zwei Varianten haben denselben Preis: ' + geld(cent, z.daten.waehrung) + '.'
    );
    if (!a.variante) meldungen.push('Für ' + geld(a.cent, z.daten.waehrung) + ' gibt es keine Variante.');
    unbekannteEbenen(z).forEach((name) => {
      meldungen.push('Eine Katalogzeile nennt die Ebene „' + name + '", die es nicht gibt.');
    });
    kasten.textContent = meldungen.join(' ');
    kasten.hidden = meldungen.length === 0;
  }

  /* Nur im Editor: eine Katalogzeile, die eine Ebene beim falschen Namen
     nennt, greift nie — und der Kunde zahlt still den Custom-Preis. */
  function unbekannteEbenen(z) {
    const bekannt = z.daten.ebenen.map((e) => e.titel);
    const genannt = [];
    z.daten.katalog.forEach((k) => Object.keys(paare(k.werte)).forEach((t) => genannt.push(t)));
    return genannt.filter((t, i) => bekannt.indexOf(t) === -1 && genannt.indexOf(t) === i);
  }

  function doppeltePreise(z) {
    const gesehen = {};
    return z.daten.varianten.filter((v) => (gesehen[v.preis] ? true : ((gesehen[v.preis] = 1), false))).map((v) => v.preis);
  }

  const ANZEIGEN = [
    zeigeEbenen,
    zeigeSonderfeld,
    zeigeVorschau,
    zeigeTon,
    zeigePreis,
    zeigeUebersicht,
    zeigeKnopf,
    zeigeEigenschaften,
    zeigeWarnung,
  ];

  function aktualisieren(z) {
    const a = auswahl(z);
    ANZEIGEN.forEach((zeigen) => zeigen(z, a));
  }

  /* ======================================================================
     6 · Aufbau
     ====================================================================== */

  const VORLAGE_RAL =
    '<span class="ug-konf__sonder-label">' + ugHtml(ugT('konf_ral_label', 'RAL-Nummer deiner Küche')) + '</span>' +
    '<span class="ug-konf__sonder-zeile">' +
    '<input class="ug-konf__sonder-eingabe" type="text" inputmode="text" autocapitalize="characters" ' +
    'placeholder="' + ugHtml(ugT('konf_ral_platzhalter', 'z. B. 7016 oder 210 50 15')) + '" autocomplete="off" data-ug-konf-ral ' +
    'aria-label="' + ugHtml(ugT('konf_ral_label', 'RAL-Nummer deiner Küche')) + '">' +
    '<span class="ug-konf__sonder-probe" data-ug-konf-probe aria-hidden="true"></span>' +
    '</span>' +
    '<p class="ug-konf__sonder-antwort" data-ug-konf-antwort aria-live="polite"></p>';

  const VORLAGE_MATERIAL =
    '<span class="ug-konf__sonder-label">' + ugHtml(ugT('konf_material_label', 'Woher kommt das Material?')) + '</span>' +
    '<span class="ug-konf__sonder-zeile">' +
    '<input class="ug-konf__sonder-eingabe" type="text" ' +
    'placeholder="' + ugHtml(ugT('konf_material_platzhalter', 'Küchenbauer oder Bezeichnung')) + '" autocomplete="off" data-ug-konf-material ' +
    'aria-label="' + ugHtml(ugT('konf_material_label', 'Woher kommt das Material?')) + '">' +
    '</span>' +
    '<p class="ug-konf__sonder-antwort">' +
    ugHtml(ugT('konf_material_antwort', 'Du schickst uns ein Muster, wir fertigen danach. Die Vorschau zeigt so lange den Standard.')) +
    '</p>';

  function optionFeld(kennung, i, j, gewaehltJ) {
    const f = document.createElement('input');
    f.type = 'radio';
    f.name = 'ug-konf-ebene-' + kennung + '-' + i;
    f.id = 'ug-konf-' + kennung + '-' + i + '-' + j;
    f.className = 'ug-konf__feld';
    f.value = String(j);
    f.checked = j === gewaehltJ;
    return f;
  }

  /* Jedes Feld traegt seinen Namen — und, wo er anfaellt, den Aufpreis.

     Vorher standen dort 22 namenlose Punkte. Den Unterschied zwischen
     Nussbaum und Raeuchereiche kann niemand raten; man musste klicken und
     schauen. Und „Echtholz kostet 15 € Aufpreis" stand als Satz UEBER der
     Reihe, ohne zu verraten, welches der sieben Felder gemeint ist.

     Der Preis gehoert an das Feld, nicht in einen Satz darueber. */
  function optionLabel(opt, fuer, aufpreis, waehrung) {
    const l = document.createElement('label');
    l.className = 'ug-konf__wert';
    l.setAttribute('for', fuer);
    l.title = opt.wert;

    if (istSonder(opt)) {
      l.classList.add('ug-konf__wert--sonder');
      l.textContent = opt.wert;
      return l;
    }

    l.classList.add('ug-konf__wert--farbe');

    const punkt = document.createElement('span');
    punkt.className = 'ug-konf__punkt';
    punkt.style.backgroundColor = opt.farbe || 'transparent';

    const name = document.createElement('span');
    name.className = 'ug-konf__wert-name';
    name.textContent = opt.wert;

    l.appendChild(punkt);
    l.appendChild(name);

    if (aufpreis > 0 && hat(opt, 'holz')) {
      const preis = document.createElement('span');
      preis.className = 'ug-konf__wert-preis';
      // Aufpreise liegen wie alle Betraege in Cent — `geld()` macht daraus
      // eine Zahl mit Waehrung. Ohne das stand dort „1500 €".
      preis.textContent = '+' + geld(aufpreis, waehrung, true);
      l.appendChild(preis);
    }
    return l;
  }

  function ebeneBauen(z, kennung, i) {
    const g = gruppe(z, i);
    const behaelter = g && g.querySelector('[data-ug-konf-werte]');
    if (!behaelter) return;
    const ebene = z.daten.ebenen[i];
    behaelter.innerHTML = '';
    ebene.optionen.forEach((opt, j) => {
      /* Feld und Kachel kommen in eine eigene Huelle.

         Das Feld ist unsichtbar, aber bedienbar, und lag als
         `position: absolute` ohne Anker am Panel statt an seiner Kachel.
         Beim Anklicken sprang die Seite dorthin, wo der Browser das Feld
         vermutete — bei „Lampe" und „Blende" also weit nach oben. Mit der
         Huelle als Bezugspunkt liegt das Feld genau auf seiner Kachel, und
         es gibt nichts mehr, wohin gesprungen werden koennte. */
      const huelle = document.createElement('div');
      huelle.className = 'ug-konf__wahl';
      const f = optionFeld(kennung, i, j, z.wahl[i]);
      huelle.appendChild(f);
      huelle.appendChild(optionLabel(opt, f.id, ebene.aufpreis, z.daten.waehrung));
      behaelter.appendChild(huelle);
    });
  }

  /* Ebenen, die mitziehen.
     ---------------------------------------------------------------------
     Wer die Gehaeusefarbe aendert, meint das Geraet — nicht nur den Sockel.
     Die Lampe springt deshalb mit, und die Blende folgt der Verkleidung.

     NUR IN EINE RICHTUNG: Wer danach unter „Lampe" etwas anderes waehlt,
     hat sich bewusst fuer eine Abweichung entschieden; das darf nicht auf
     das Gehaeuse zurueckschlagen.

     Verglichen wird ueber den Namen der Option, nicht ueber ihre Position:
     die Verkleidung hat sieben Optionen, die Lampe vier. „Beige" trifft
     „Beige", und was es drueben nicht gibt, bleibt stehen. */
  function mitziehen(z, i) {
    const quelle = z.daten.ebenen[i];
    if (!quelle || !quelle.schluessel) return;
    const wert = (gewaehlt(z, i) || {}).wert;
    if (!wert) return;

    z.daten.ebenen.forEach((ebene, j) => {
      if (j === i || ebene.folgt_ebene !== quelle.schluessel) return;
      const treffer = ebene.optionen.findIndex((o) => o.wert === wert);
      if (treffer !== -1) z.wahl[j] = treffer;
    });
  }

  function bindenWahl(z) {
    z.wurzel.addEventListener('change', (e) => {
      if (!e.target.matches('.ug-konf__feld')) return;
      const g = e.target.closest('[data-ug-konf-gruppe]');
      if (!g) return;
      const i = Number(g.dataset.ugKonfGruppe);
      z.wahl[i] = Number(e.target.value);
      mitziehen(z, i);
      aktualisieren(z);
    });
  }

function bindenEingabe(z) {
  z.wurzel.addEventListener('input', (e) => {
    if (e.target.matches('[data-ug-konf-ral]')) {
      z.ral = Object.assign({}, z.ral, { eingabe: e.target.value });
      ralPruefen(z);
    } else if (e.target.matches('[data-ug-konf-material]')) {
      z.material = e.target.value;
      aktualisieren(z);
    }
  });
}

function datenLesen(wurzel) {
  const abschnitt = wurzel.closest('.shopify-section');
  const quelle = abschnitt && abschnitt.querySelector('[data-ug-konf-daten]');
  if (!quelle) return null;
  try {
    return {
      daten: JSON.parse(quelle.textContent),
      kennung: quelle.getAttribute('data-ug-konf-daten')
    };
  } catch (e) {
    return null;
  }
}

function starteEinen(wurzel) {
  if (wurzel.dataset.ugBereit) return;
  wurzel.dataset.ugBereit = '1';

  const gelesen = datenLesen(wurzel);
  if (!gelesen) return;

  const z = {
    wurzel,
    daten: gelesen.daten,
    wahl: gelesen.daten.ebenen.map((ebene) => {
      if (!ebene.vorgabe) return 0;
      const i = ebene.optionen.findIndex((o) => o.wert === ebene.vorgabe);
      return i === -1 ? 0 : i;
    }),
    ral: Object.assign({}, RAL_LEER),
    material: '',
  };

  ausAdresse(z);

  const text = teil(z, 'knopf-text');
  if (text) text.dataset.ugStandard = text.textContent.trim();

  z.daten.ebenen.forEach((_, i) => ebeneBauen(z, gelesen.kennung, i));
    bindenWahl(z);
  bindenEingabe(z);
  aktualisieren(z);
  sonderfeldFuellen(z);

  ugEvent('upgreens:configurator_started', {
    page: window.location.pathname,
    herkunft: herkunft()
  });
}
  const start = () => document.querySelectorAll('[data-ug-konf]').forEach(starteEinen);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Der Theme-Editor baut Sektionen neu auf
  document.addEventListener('shopify:section:load', start);
})();
